/**
 * @generated SignedSource<<d9e1a64a1d5b2524d9be014939ded5cc>>
 * @relayHash 71d9d515e142947a1c45d7fda112ca6f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71d9d515e142947a1c45d7fda112ca6f

import { ConcreteRequest } from 'relay-runtime';
export type MarkAllThreadMessagesAsReadInput = {
  threadId: string;
};
export type useMarkAllThreadMessagesAsReadMutation$variables = {
  input: MarkAllThreadMessagesAsReadInput;
};
export type useMarkAllThreadMessagesAsReadMutation$data = {
  readonly markAllThreadMessagesAsRead: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly threadId?: string;
    }> | null;
    readonly markThreadReadOutput: {
      readonly threadId: string;
    } | null;
  };
};
export type useMarkAllThreadMessagesAsReadMutation = {
  response: useMarkAllThreadMessagesAsReadMutation$data;
  variables: useMarkAllThreadMessagesAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MarkThreadReadOutput",
  "kind": "LinkedField",
  "name": "markThreadReadOutput",
  "plural": false,
  "selections": [
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ChatThreadNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMarkAllThreadMessagesAsReadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "MarkAllThreadMessagesAsReadPayload",
        "kind": "LinkedField",
        "name": "markAllThreadMessagesAsRead",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useMarkAllThreadMessagesAsReadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "MarkAllThreadMessagesAsReadPayload",
        "kind": "LinkedField",
        "name": "markAllThreadMessagesAsRead",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "71d9d515e142947a1c45d7fda112ca6f",
    "metadata": {},
    "name": "useMarkAllThreadMessagesAsReadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ba6fd024388a206d3e96b9d711cec021";

export default node;
